import { observer } from 'mobx-react';
import { PDFViewerPanel } from '../PDFViewerPanel/PDFViewerPanel';
import { MDViewerPanel } from '../MDViewerPanel/MDViewerPanel';

interface IFileViewer {
    fileName: string;
    title_display: string;
}

export const FileViewerPanel = observer((props: IFileViewer) => {
    if (!props.fileName) {
        return null;
    }

    let url = props.fileName;
    if (url.indexOf('?') > -1) {
        url = url.split('?')[0];
    }

    const fileExt = url.split('.').slice(-1)[0].toLowerCase();

    if (fileExt === 'pdf') {
        return (
            <PDFViewerPanel
                pdfUrl={props.fileName}
                title_display={props.title_display}
            />
        );
    } else if (fileExt == 'md') {
        return (
            <MDViewerPanel
                mdFileUrl={props.fileName}
                title_display={props.title_display}
            />
        );
    } else {
        return <div>Unsupported file type: {fileExt}</div>;
    }
});
